import type { SentryScopeTags } from '../sentry-scope';

/** Route as a tag, not as grouping: transport errors group per error class, so the tag breakdown is
 *  what tells a hanging endpoint from connectivity noise. */
export function enrichRequestScope(error: { route?: string; url: string; method: string }, scope: SentryScopeTags): void {
  if (error.route) {
    scope.setTag('route', error.route);
  }
  scope.setContext('request', { url: error.url, method: error.method });
}
